import {XauditModel} from '../xaudit.model';

export class CfgArClaimProcessorModel extends XauditModel {
  ClaimProcessorID: string;
  Name: string;
  enumARClaimProcessorID: string;
  WebSiteURL: string;
  ConnectionParametersJSON: string;
}
